import { createHttpEndpoint } from '../../utils'

/**
 * Update Client password
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/password/operation/updateClientPassword}
 */
export const updatePassword = createHttpEndpoint({
  method: 'PUT',
  operationId: 'updateClientPassword',
  path: '/bm/client/update_password',
})
